module.exports = __webpack_public_path__ + "static/media/action-two-rings.b5484379.svg";